<template>
    <div class="applyIndex" v-if="init" :style="{padding: hideHeader ? '0' : (showAppTips ? '1.98rem 0 0' : '0.88rem 0 0')}">
        <mHeader v-if="!hideHeader"></mHeader>
        <mBanner></mBanner>
        <div class="m-body">
            <div class="recommend">
                <div class="applyIndex-title">
                    <span class="icon-aa-recommend title blod">推荐活动</span>
                    <div class="custom-indicator">
                        <i class="dot" :class="[current==idex? 'active':'']" v-for="(i,idex) in Math.ceil(item.recommendlist.length/4)" :key="i"></i>
                    </div>
                </div>
                <van-swipe :autoplay="3000"  v-if="item.recommendlist.length" @change="onChange">
                    <van-swipe-item v-for="(i,idex) in Math.ceil(item.recommendlist.length/4)" :key="i">
                        <div class="outbox container">
                            <div class="box" v-for="(obj) in item.recommendlist.slice(idex*4, idex*4 + 4)" :key="obj.eventid" @click="gotoView(obj)">
                                <div class="top"><img class="img" v-lazy="obj.eventlogo" alt=""></div>
                                <div class="bottom">
                                    <div class="title text-ellipses">{{obj.title}}</div>
                                    <div class="info">
                                        <div class="tc-grey">{{obj.begintime}} - {{obj.endtime}}</div>
                                        <div class="tc-grey">{{obj.areaname}}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="new">
                <div class="applyIndex-title">
                    <span class="icon-aa-new title blod">最新活动</span>
                    <span class="arrow icon-aa-right tc-grey" @click="handleMore">更多</span>
                </div>
                <div class="container">
                    <div class="box" v-for="(obj) in item.newevent" :key="obj.eventid" @click="gotoView(obj)">
                        <div class="left"><img class="img" v-lazy="obj.eventlogo" alt=""></div>
                        <div class="right">
                            <div class="title text-ellipses">{{obj.title}}</div>
                            <div class="info">
                                <div class="tc-grey">{{obj.begintime}} - {{obj.endtime}}</div>
                                <div class="tc-grey">{{obj.areaname}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="active">
                <div class="applyIndex-title">
                    <span class="icon-aa-active title blod">活跃主办方</span>
                    <span></span>
                </div>
                <div class="outbox container">
                    <div class="box" v-for="(obj,i) in item.activehost" :key="i">
                        <img :src="obj.hostpic" :alt="obj.hostname"  @click="gotoHost(obj)">
                        <div class="hostname text-ellipse" @click="gotoHost(obj)">{{obj.hostname}}</div>
                        <div class="btn isfollow" v-if="!obj.isfollow" @click="handleFollow(obj, 1)">+ 关注</div>
                        <div class="btn" v-else @click="handleFollow(obj, 2)">已关注</div>
                    </div>
                </div>
            </div>
            <div class="rank">
                <div class="applyIndex-title">
                    <span class="icon-aa-hot title blod">热门活动</span>
                    <span class="arrow icon-aa-right tc-grey" @click="handleMore">更多</span>
                </div>
                <div class="container">
                    <div class="box" v-for="(obj) in item.ranklist" :key="obj.eventid" @click="gotoView(obj)">
                        <div class="left"><img class="img" v-lazy="obj.eventlogo" alt=""></div>
                        <div class="right">
                            <div class="title text-ellipses">{{obj.title}}</div>
                            <div class="info">
                                <div class="tc-grey">{{obj.begintime}} - {{obj.endtime}}</div>
                                <div class="tc-grey">{{obj.areaname}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="applyIndex-footer" @click="handleMore">查看更多活动</div>
        </div>
        <!-- <mTab></mTab> -->
    </div>
</template>

<script>
  import MHeader from 'views/mobile/components/mheader/mHeader'
  import MBanner from 'views/mapply/components/mBanner.vue'
  // import MTab from 'views/mapply/components/mTab.vue'
  // import MTab from 'views/mobile/components/tab/mTab'
  import {getIndexInfo, operateHostFollowInfo} from 'api/activeTools'
  import {mapGetters, mapActions} from 'vuex'
  import {getWXSDKSetting} from 'common/js/wxSDKSetting'

  export default {
    name: 'applyIndex',
    data() {
      return {
        init: false,
        item: {
          activehost: [],
          newevent: [],
          ranklist: [],
          recommendlist: [],
        },
        current: 0,
        hideHeader: false
      }
    },
    created() {
      if(!this.domainInfo.isMobile){
        this.$router.push({name: 'HdIndex'})
      }
      if (this.$route.query.isinner && this.$route.query.isinner == 1) {
            this.hideHeader = true
        } else {
            this.hideHeader = false
        }
    },
    mounted() {
      document.title = '鲸融活动'
      if (this._isWixin()) {
        let link = window.location.protocol + '//' + window.location.host + window.location.pathname
        getWXSDKSetting({
          title: '鲸融活动_商业活动优选服务平台-鲸融网',
          desc: '鲸融活动是鲸融网旗下的商业活动优选服务平台，致力于帮助商业活动主办方办好每一场活动，​拉进与客户、投资人、初创企业之间的距离，从而实现跟进一步的合作。',
          link: link,
          imgUrl: 'http://img.capwhale.com/capwhale_logo.png'
        })
      }
      if (!this.refresh) {
        this.getList()
      }
    },
    activated() {
      if (this.user.isLogin && !this.init && this.refresh) {
        this.getList()
        this.setRefresh(false)
      }
    },
    methods: {
      _isWixin() {
        let ua = window.navigator.userAgent.toLowerCase()
        if (/micromessenger/.test(ua)) {
          return true
        } else {
          return false
        }
      },
      handleMore() {
        this.$router.push({name: 'ApplyList', query: {key: ''}})
      },
      gotoHost(obj) {
        this.setRefresh(true)
        this.$router.push({name: 'AaHostView', query: {hostid: obj.hostid}})
      },
      gotoView(obj) {
        if (obj.enrolleventsource == 1) {
          this.setRefresh(true)
          this.$router.push({name: 'ActivityDetail', query: {eventid: obj.eventid}})
        } else {
          window.location.href = obj.enrolllinkurl
        }
      },
      handleFollow(obj, optype) {
        if (this.user.isLogin) {
          let param = {
            hostid: obj.hostid,
            optype: optype, // 操作类型 1关注 2取消关注
          }
          if (optype == 2) {
            this.$dialog.confirm({
              title: '提示',
              message: '确定取消关注？'
            }).then(() => {
              this._setFollow(obj, param)
            }).catch(() => {})
          } else {
            this._setFollow(obj, param)
          }
        } else {
          this.setRefresh(true)
          this.$toast.fail('请先登录')
          this.$router.push({name: 'MLogin'})
        }
      },
      onChange(index) {
        this.current = index;
      },
      _setFollow(obj, param) {
        this.setLoading(true)
        operateHostFollowInfo({
          data: param,
          success: () => {
            obj.isfollow = param.optype == 2 ? 0 : 1
            this.$toast.success('操作成功')
            this.setLoading(false)
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      getList() {
        this.setLoading(true)
        getIndexInfo({
          data: {},
          success: data => {
            this.item = data.data
            this.init = true
            this.setLoading(false)
          },
          error: data => {
            this.setLoading(false)
            this.$toast.fail(data.msg)
          }
        })
      },
      ...mapActions([
        'setLoading',
        'setNoDataTip',
        'setRefresh'
      ])
    },
    filters: {},
    watch: {},
    computed: {
      ...mapGetters([
        'user', 'refresh', 'domainInfo', 'showAppTips'
      ])
    },
    components: {
      MHeader, MBanner
    }
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    @import "~common/scss/variable";

    .applyIndex {
        background: #fff;
        position: relative;
        padding: 0.88rem 0 0;
        .m-body{
            /*padding: 0 0.32rem;*/
        }
        .applyIndex-footer{
            padding: 0.16rem 0 0.32rem 0;
            font-size: 0.24rem;
            text-align: center;
            color: #999999;
        }
        .container{
            padding: 0 0.32rem;
        }
        .applyIndex-title{
            padding: 0.16rem 0.32rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title{
                display: flex;
                align-items: center;
                font-size: 0.28rem;
                &:before{
                    width: 0.32rem;
                    height: 0.32rem;
                    margin-right: 0.2rem;
                }
            }
            .arrow{
                display: flex;
                align-items: center;
                font-size: 0.24rem;
                &:after{
                    width: 0.16rem;
                    height: 0.26rem;
                    margin-left: 0.12rem;
                }
            }
        }
        .recommend{
            .van-swipe__indicators{
                display: none;
            }
            .custom-indicator{
                .dot{
                    display: inline-block;
                    margin-left: 0.12rem;
                    width: 0.12rem;
                    height: 0.12rem;
                    border-radius: 0.06rem;
                    background: #E5E5E5;
                    transition: all .3s;
                }
                .dot.active{
                    width: 0.42rem;
                    background: #0ABF53 ;
                }
            }
            .outbox{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                padding: 0.16rem 0.32rem;
            }
            .box:nth-child(4n+1),.box:nth-child(4n+2){
                margin-bottom: 0.32rem;
            }
            .box{
                width: 3.29rem;
                height: 3.8rem;
                box-shadow:0 0 0.1rem 0 rgba(0,0,0,0.2);
                border-radius:0.06rem;
                box-sizing: border-box;
                .top{
                    img{
                        width: 3.29rem;
                        height: 1.84rem;
                        margin-botom: 0.12rem;
                    }
                }
                .bottom{
                    margin: 0.12rem 0.12rem 0 0.12rem;
                    .title {
                        height: 0.8rem;
                        font-weight: 600;
                        line-height: 0.4rem;
                        font-size: 0.28rem;
                    }
                    .info {
                        margin-top: 0.12rem;
                        font-size: 0.24rem;
                        line-height: 0.32rem;
                        div+div{
                            margin-top: 0.08rem;
                        }
                    }
                }
            }
        }
        .new .box, .rank .box {
            display: flex;
            justify-content: flex-start;
            font-size: 0.28rem;
            font-weight: 600;
            background: $c-white;
            padding: 0.16rem 0;
            .left {
                min-width: 3rem;
                max-width: 3rem;
                width: 3rem;
                height: 1.67rem;
                margin-right: 0.2rem;
                .img {
                    width: 100%;
                    height: 100%;
                    border-radius: 0.04rem;
                }
            }
            .right {
                width: 4.65rem;
                .title {
                    max-height: 0.8rem;
                    font-weight: 600;
                    line-height: 0.4rem;
                }
                .info {
                    margin-top: 0.12rem;
                    font-size: 0.24rem;
                    line-height: 0.32rem;
                    div+div{
                        margin-top: 0.08rem;
                    }
                }
            }
        }
        .active{
            .outbox{
                overflow-y: auto;
                display: flex;
                padding: 0.16rem 0;
                margin: 0 0.32rem;
                &::-webkit-scrollbar {
                    display:none
                }
                .box{
                    width: 2.5rem;
                    min-width: 2.5rem;
                    max-width: 2.5rem;
                    display: flex;
                    flex-direction: column;
                    img{
                        width: 1.36rem;
                        height: 1.36rem;
                        border-radius: 0.06rem;
                    }
                    .hostname{
                        font-size:0.28rem;
                        font-weight:600;
                        color:rgba(0,0,0,1);
                        line-height:0.4rem;
                        margin-top: 0.24rem;
                    }
                    .btn{
                        color: #999999 ;
                        border: 1px solid  #DDDDDD;
                        border-radius:0.04rem;
                        width: 1.16rem;
                        height: 0.52rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-top: 0.2rem;
                        font-size: 0.28rem;
                    }
                    .btn.isfollow{
                        color: #0ABF53;
                        border: 1px solid #0ABF53;
                    }
                }
                .box+.box{
                    margin-left: 0.24rem;
                }
            }
        }
    }
</style>